import API from '../../../../services/API';

export default function searchKbk(searchKey) {
  return API.request(
    {
      method: 'GET',
      url: `/dicts/oktmo`,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      params: {
        searchKey,
      },
    },
    true,
  ); //is cancelable
}
